// create the back to top button
jQuery('body').prepend('<a href="#" class="back-to-top">Back to Top</a>');
var amountScrolled = 300;
jQuery(window).scroll(function() {
  if (jQuery(window).scrollTop() > amountScrolled ) {
    jQuery('a.back-to-top').fadeIn('slow');
  } else {
    jQuery('a.back-to-top').fadeOut('slow');
  }
});

jQuery('a.back-to-top, a.simple-back-to-top').click(function() {
  jQuery('html, body').animate({
    scrollTop: 0
  }, 700);
  return false;
});



$(window).scroll(function(){
  var sticky = $('.top-header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});


// Top slider script 
$(document).ready(function() {
  $("#owl-demo").owlCarousel({
    navigation : true, // Show next and prev buttons
    autoPlay:5000,
    
    navigationText: ["<i class='fa fa-chevron-circle-left'></i>","<i class='fa fa-chevron-circle-right'></i>"],
    
    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    paginationSpeed : 1000,
    pagination: false,
    singleItem:true
  });
  // home page blog slider
  $("#owl-blog").owlCarousel({
    autoPlay: false, //Set AutoPlay to 4 seconds
    items : 3,
    itemsDesktop : [1199,3],
    itemsDesktopSmall : [979,3],
    nav: true
  });


  // Brand slider Js
  $("#owl-brand").owlCarousel({
    autoPlay: 4000, //Set AutoPlay to 3 seconds
    pagination: false,
    navigation : true,
    navigationText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
    items : 5,
  });



});


// Match height js
$(function() {
  $('.blog-image').matchHeight();
  $('.product-img-box').matchHeight(); 
  $('.item-infos').matchHeight();
  $('.home_blog1').matchHeight();
  //$('.product-item').matchHeight();
  
  
});



$(document).ready(function () {

  var $lis = $(".rainbow li").hide();
  $lis.slice(0,4).show();
  var size_li = $lis.length;
  var x = 4,
      start = 0;
  $('#next').click(function () {
    if (start + x < size_li) {
      $lis.slice(start, start + x).hide();
      start += x;
      $lis.slice(start, start + x).fadeIn('slow');

    }
  });
  $('#prev').click(function () {
    if (start - x >= 0) {
      $lis.slice(start, start + x).hide();
      start -= x;
      $lis.slice(start, start + x).fadeIn('slow');
    }
  });

});





$('.footer-col-title').on('click', function(event){
   alert('test');
    var accordion = jQuery(this);
    var accordionContent = accordion.next('div');
    var accordionToggleIcon = jQuery(this).children('.toggle-icon');
    accordion.toggleClass("open");
    accordionContent.slideToggle(250);
});